import MaintenanceEventReducer from './MaintenanceEventReducer.js';
import Constants from '../Constants.js';
const {
  getStatus,
  getMaintenanceEvents,
  getError
} = MaintenanceEventReducer;
const {
  MAINTENANCE_EVENT_ADD,
  MAINTENANCE_EVENT_STATUS,
  MAINTENANCE_EVENT_LIST,
  MAINTENANCE_EVENT_LIST_ACTIVE
} = Constants;
class MaintenanceEvents {
  constructor(projectId) {
    this.projectId = projectId || process?.env?.projectId;
  }
  createAction(method, status, func) {
    return (dispatch, getState, opts) => {
      const projectId = this.projectId || opts && opts.api && opts.api.projectId;
      dispatch({
        type: MAINTENANCE_EVENT_STATUS,
        status,
        projectId
      });
      return func(dispatch, getState, opts, projectId).catch(error => {
        dispatch({
          type: MAINTENANCE_EVENT_STATUS,
          projectId,
          status: `${method}Error`,
          error
        });
        return Promise.reject(error);
      });
    };
  }
  listActive(options) {
    return this.createAction('listActive', 'listingActive', async (dispatch, getState, {
      api
    }, projectId = this.projectId) => {
      if (!projectId) {
        return null;
      }
      const listEventRes = await api.project(projectId).activeMaintenanceEvents().list(options);
      dispatch({
        type: MAINTENANCE_EVENT_LIST_ACTIVE,
        projectId,
        items: listEventRes.items
      });
      return listEventRes;
    });
  }
  list(options = {}) {
    return this.createAction('list', 'loading', async (dispatch, getState, {
      api
    }, projectId = this.projectId) => {
      let listEventReq = api;
      if (projectId) {
        listEventReq = listEventReq.project(projectId);
      }
      const listEventRes = await listEventReq.maintenanceEvents().list(options);
      dispatch({
        type: MAINTENANCE_EVENT_LIST,
        projectId,
        items: listEventRes.items
      });
      return listEventRes;
    });
  }
  create(event) {
    const action = async (dispatch, getState, {
      api
    }, projectId = this.projectId) => {
      let createEventReq = api;
      if (projectId) {
        createEventReq = createEventReq.project(projectId);
      }
      const createEventRes = await createEventReq.maintenanceEvents().create(event);
      dispatch({
        type: MAINTENANCE_EVENT_ADD,
        projectId,
        event: createEventRes
      });
      return createEventRes;
    };
    return this.createAction('create', 'creating', action);
  }
  getStatus(state, id = null) {
    return getStatus(state, this.projectId, id);
  }
  getError(state, id = null) {
    return getError(state, this.projectId, id);
  }
  getMaintenanceEvents(state) {
    return getMaintenanceEvents(state, this.projectId);
  }
}
export default MaintenanceEvents;